import {
  TM_TEACHERS_REQUEST,
  TM_TEACHERS_SUCCESS,
  TM_TEACHERS_FAILURE,
  TM_CREATE_COURSE_REQUEST,
  TM_CREATE_COURSE_SUCCESS,
  TM_CREATE_COURSE_FAILURE,
  TM_COURSES_REQUEST,
  TM_COURSES_SUCCESS,
  TM_COURSES_FAILURE,
  TM_UPDATE_COURSE_REQUEST,
  TM_UPDATE_COURSE_SUCCESS,
  TM_UPDATE_COURSE_FAILURE,
  TM_CLEAR_TEACHERS_ERROR,
  TM_CLEAR_CREATE_ERROR,
  TM_CLEAR_COURSES_ERROR,
  TM_CLEAR_CREATE_SUCCESS,
  TM_CLEAR_UPDATE_STATE,
} from "../Actions/teacherManagerCourseActions";

const initialState = {
  teachers: [],
  teachersLoading: false,
  teachersError: null,

  courses: [],
  coursesLoading: false,
  coursesError: null,

  createLoading: false,
  createSuccess: false,
  createdCourse: null,
  createError: null,

  updateLoading: false,
  updateSuccess: false,
  updateMessage: null,
  updateError: null,
};

export const teacherManagerCourseReducer = (state = initialState, action) => {
  switch (action.type) {
    case TM_TEACHERS_REQUEST:
      return { ...state, teachersLoading: true, teachersError: null };

    case TM_TEACHERS_SUCCESS:
      return { ...state, teachersLoading: false, teachers: action.payload || [] };

    case TM_TEACHERS_FAILURE:
      return { ...state, teachersLoading: false, teachersError: action.payload };

    case TM_COURSES_REQUEST:
      return { ...state, coursesLoading: true, coursesError: null };

    case TM_COURSES_SUCCESS:
      return { ...state, coursesLoading: false, courses: action.payload || [] };

    case TM_COURSES_FAILURE:
      return { ...state, coursesLoading: false, coursesError: action.payload };

    case TM_CREATE_COURSE_REQUEST:
      return {
        ...state,
        createLoading: true,
        createSuccess: false,
        createError: null,
        createdCourse: null,
      };

    case TM_CREATE_COURSE_SUCCESS:
      return {
        ...state,
        createLoading: false,
        createSuccess: true,
        createdCourse: action.payload,
      };

    case TM_CREATE_COURSE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createSuccess: false,
        createError: action.payload?.message || action.payload,
      };
    case TM_UPDATE_COURSE_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateSuccess: false,
        updateError: null,
        updateMessage: null,
      };
    case TM_UPDATE_COURSE_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateSuccess: true,
        updateMessage: action.payload?.message || "Course updated successfully",
      };
    case TM_UPDATE_COURSE_FAILURE:
      return {
        ...state,
        updateLoading: false,
        updateSuccess: false,
        updateError: action.payload?.message || action.payload,
      };
    case TM_CLEAR_TEACHERS_ERROR:
      return { ...state, teachersError: null };
    case TM_CLEAR_CREATE_ERROR:
      return { ...state, createError: null };
    case TM_CLEAR_COURSES_ERROR:
      return { ...state, coursesError: null };
    case TM_CLEAR_CREATE_SUCCESS:
      return { ...state, createSuccess: false, createdCourse: null };
    case TM_CLEAR_UPDATE_STATE:
      return { ...state, updateSuccess: false, updateError: null, updateMessage: null };

    default:
      return state;
  }
};
